import React from 'react'
import { Outlet } from 'react-router-dom'

const SiteContent = () => {

    return (
        <main className='site-main'>
            <Outlet />
        </main>
    )
}

export default SiteContent